import { ClientTypeEnum } from 'src/clients/client-type-enum';
import { client } from '../../clients/client';

/**
 * Constantes utilisées pour : 
 * - Les URI des services à appeler
 * - Les URLs pour les redirections (certaines sont déterminées en fonction du contexte MOBILE OU WEB)
 */
export class ConstanteUri {

  /**
   * Bouchon d'un flux stocké en session
   */
  static URL_CALCUL_USAGER_MODEL_BOUCHON = "/assets/data/pagefin/declarationModel.json";

  /**
   * Bouchon d'un flux stocké en session pour ACCESSION
   */
  static URL_CALCUL_USAGER_MODEL_BOUCHON_ACCESSION = "/assets/data/pagefin/declarationModelAccession.json";


  /**
   * URI pour le service qui calcul le droit AL
   */
  static URI_CALCUL = "/api/prestationalmiddle/v1/simuler";

  /**
   * Définition du redirect pour quitter l'application par type de client (MOBILE / WEB)
   */
  private static MAP_TYPE_CLIENT_URL_EXIT = new Map<ClientTypeEnum, string>([
      [ClientTypeEnum.WEB, '/redirect/s/Redirect?page=monCompte'],
      [ClientTypeEnum.MOBILE, '/redirect/s/Redirect?page=applimobileMonCompte'],
    ]
  );

  /**
   * Lien utilisé pour quitter l'application
   */
  public static URL_REDIRECT_EXIT = ConstanteUri.MAP_TYPE_CLIENT_URL_EXIT.get(client.type);

  /**
   * Lien utilisé pour rediriger vers la demande AL pour les résident de Mayotte
   */
  public static URL_REDIRECT_MAYOTTE = "https://www.caf.fr/allocataires/caf-de-mayotte/offre-de-service";

  /**
   * Lien utilisé pour rediriger vers mon compte en mode allocataire
   */
  public static URL_REDIRECT_ALLOC = "/redirect/s/Redirect?page=monCompteFormulairesSelectMetroDom";

  
}
